import React, { useState, useEffect } from 'react';
import { dashboardService, DashboardStatistics } from '../../services/dashboardService';

interface StatsData {
  totalDocuments: number;
  processedDocuments: number;
  pendingDocuments: number;
  totalFolders: number;
}

export const StatsBignumbers: React.FC = () => {
  const [stats, setStats] = useState<StatsData>({
    totalDocuments: 0,
    processedDocuments: 0,
    pendingDocuments: 0,
    totalFolders: 0
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchStats = async () => {
    try {
      setIsLoading(true);
      
      // Buscar estatísticas do dashboard da API
      const dashboardStats: DashboardStatistics = await dashboardService.getDashboardStatistics();
      
      // Usar os campos do backend calculados via DocumentIndexedWorkspace
      const statsData: StatsData = {
        totalDocuments: dashboardStats.documentStatistics.totalDocuments || 0,
        processedDocuments: dashboardStats.documentStatistics.documentsCompleted || 0,
        pendingDocuments: dashboardStats.documentStatistics.documentsPendingApproval || 0,
        totalFolders: dashboardStats.documentStatistics.totalFolders || 0
      };
      
      setStats(statsData);
      setError(null);
    } catch (err) {
      console.error('Erro ao buscar estatísticas:', err);
      setError('Não foi possível carregar as estatísticas.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return (
  <div className="bg-white rounded-lg shadow-md p-6">
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-lg font-semibold">Estatísticas</h2>
      <div className="flex items-center gap-2">
        <button 
          onClick={() => {
            fetchStats();
          }}
          className="text-xs px-2 py-1 bg-blue-100 text-blue-600 rounded hover:bg-blue-200"
        >
          Atualizar
        </button>
      </div>
    </div>
    
    {isLoading ? (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    ) : error ? (
      <div className="text-center text-red-500 py-4">{error}</div>
    ) : (
      <div className="grid grid-cols-2 gap-4">
        <div className="border rounded-lg p-4 text-center">
          <p className="text-3xl font-bold text-blue-600">{stats.totalDocuments}</p>
          <p className="text-sm text-gray-600">Documentos</p>
        </div>
        <div className="border rounded-lg p-4 text-center">
          <p className="text-3xl font-bold text-green-600">{stats.processedDocuments}</p>
          <p className="text-sm text-gray-600">Processados</p>
        </div>
        <div className="border rounded-lg p-4 text-center">
          <p className="text-3xl font-bold text-yellow-600">{stats.pendingDocuments}</p>
          <p className="text-sm text-gray-600">Pendentes</p>
        </div>
        <div className="border rounded-lg p-4 text-center">
          <p className="text-3xl font-bold text-purple-600">{stats.totalFolders}</p>
          <p className="text-sm text-gray-600">Pastas</p>
        </div>
      </div>
    )}
  </div>
  );
};